import { render, staticRenderFns } from "./XMLTag.vue?vue&type=template&id=da1bf552&scoped=true"
import script from "./XMLTag.vue?vue&type=script&lang=js"
export * from "./XMLTag.vue?vue&type=script&lang=js"
import style0 from "./XMLTag.vue?vue&type=style&index=0&id=da1bf552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1bf552",
  null
  
)

export default component.exports